import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

// Helpers
import { findRootPredicateUuid } from '../helpers';

/**
 * Get a predicate element from store by ID
 * @param {string} id
 * @returns object | null
 */
export const useCriteriaStoreRootUuid = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);

    return findRootPredicateUuid(predicates);
};
